import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import {
    convertStoreSettingsToResource,
    convertStoreSettingsToModel
} from './store-read-settings/store-read-settings.util';
import {
    convertFormatSettingsToResource,
    convertFormatSettingsToModel
} from './format-read-settings/format-read-settings.util';
import { AvroCopySource } from 'app/model/pipeline/copysource/avro.source';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AvroCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        storeSettings: '*',
        formatSettings: '*'
    }
})
export class AvroCopySourceAdapter extends CopySourceAdapter<AvroCopySource, Model.AvroSource> {
    protected override async _toResource(copySource: AvroCopySource): Promise<Model.AvroSource> {
        const result: Model.AvroSource = this.getCommonCopySourceProperties(copySource, AvroCopySource.MODEL.name);

        await convertStoreSettingsToResource(copySource.storeSettings, result, this.context);
        await convertFormatSettingsToResource(copySource.formatSettings, result, this.context);

        return result;
    }

    protected override async _toModel(source: Model.AvroSource, copyActivity: CopyActivity): Promise<AvroCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            AvroCopySource.MODEL,
            source,
            copyActivity
        ) as AvroCopySource;

        await convertStoreSettingsToModel(source.storeSettings, result, this.context);
        await convertFormatSettingsToModel(source.formatSettings, result, this.context);
        return result;
    }
}
